import React, { useState, useEffect, useRef } from "react";
import "./TagInput.css";

export default function TagInput({
  sourceClass = "",
  users = [],
  value = [],
  onChange,
  placeholder = "Ajouter un participant...",
  allowCustomEmail = false,   // ⭐ nouvelle option
  nonRemovableEmails = [],
}) {
  const tagInputRef = useRef(null);
  const [query, setQuery] = useState("");
  const [showList, setShowList] = useState(false);

  const filteredUsers = users.filter(
    (u) =>
      u.display_name.toLowerCase().includes(query.toLowerCase()) &&
      !value.find((v) => v.id === u.id)
  );

  const addUser = (user) => {
    onChange([...value, user]);
    setQuery("");
    setShowList(false);
  };

  const removeUser = (id) => {
    onChange(value.filter((u) => u.id !== id));
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tagInputRef.current && !tagInputRef.current.contains(event.target)) {
        setShowList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const addEmailFromInput = () => {
    if (!allowCustomEmail) return;
    if (!emailRegex.test(query)) return;
    const emailExists = value.some(u => u.email === query);
    if (emailExists) return;

    onChange([
      ...value,
      { email: query }
    ]);

    setQuery("");
    setShowList(false);
  };

  return (
    <div className={`tag-input ${sourceClass}`} ref={tagInputRef}>

      <div className="tags-container">

        {value.map((user) => (
          <div key={user.id} className="tag">

            {(user.urlphoto && user.display_name !== "Guest") && (
              <img src={user.urlphoto} alt="" />
            )}

            {(user.display_name && user.display_name !== "Guest") ? user.display_name : user.email}

            {!nonRemovableEmails.map(e => e?.toLowerCase()).includes(user.email?.toLowerCase()) && (
              <span className="remove" onClick={() => removeUser(user.id)}>✕</span>
            )}

          </div>
        ))}

        <input
          value={query}
          placeholder={placeholder}
          onFocus={() => setShowList(true)}
          onChange={(e) => {
            setQuery(e.target.value);
            setShowList(true);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addEmailFromInput();
            }
          }}
        />

        {allowCustomEmail && emailRegex.test(query) && (
          <div
            className="autocomplete-item add-email"
            onClick={addEmailFromInput}
          >
            Ajouter
          </div>
        )}

      </div>

      {showList && filteredUsers.length > 0 && (
        <div className="autocomplete">

          {filteredUsers.map((user) => (
            <div
              key={user.id}
              className="autocomplete-item"
              onClick={() => addUser(user)}
            >

              {user.urlphoto && (
                <img src={user.urlphoto} alt="" />
              )}

              <span className="name">
                {user.display_name}
                <small>
                  {user.email}
                </small>
              </span>

            </div>
          ))}

        </div>
      )}

    </div>
  );
}